import { render, staticRenderFns } from "./addSections.vue?vue&type=template&id=0268ffd9&scoped=true"
import script from "./addSections.vue?vue&type=script&lang=js"
export * from "./addSections.vue?vue&type=script&lang=js"
import style0 from "./addSections.vue?vue&type=style&index=0&id=0268ffd9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0268ffd9",
  null
  
)

export default component.exports